<template>
  <div class="page" :class="{'page__has-bar': !readonly}">
    <div class="page__bd">
      <div class="form-preview weui-form-preview">
        <div class="weui-form-preview__hd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">单据编号</label>
            <em class="weui-form-preview__value">{{form.main.sf_code}}</em>
          </div>
        </div>
        <custom-layout class="weui-form-preview__bd" :view-config="customViewConfig">
          <div class="weui-form-preview__item" slot="sf_currency">
            <label class="weui-form-preview__label">{{
              customLabel.sf_currency || "币种"
            }}</label>
            <em class="weui-form-preview__value">{{form.main.sf_currency}}</em>
          </div>
          <div class="weui-form-preview__item" slot="sf_taxrate">
            <label class="weui-form-preview__label">{{
              customLabel.sf_taxrate || "税率(%)"
            }}</label>
            <span class="weui-form-preview__value">{{form.main.sf_taxrate}}</span>
          </div>
          <div class="weui-form-preview__item" slot="sf_clashway">
            <label class="weui-form-preview__label">{{
              customLabel.sf_clashway || "类型"
            }}</label>
            <span
              class="weui-form-preview__value"
            >{{form.main.sf_clashway=='ALL'?'任意订单自动核销':'按备货客户核销'}}</span>
          </div>
          <custom-field :readOnly="true" :label="customLabel.sf_text1 || '自定义字段1'"
          v-model="form.main.sf_text1" slot="sf_text1" hidden="true" />
          <custom-field :readOnly="true" :label="customLabel.sf_text2 || '自定义字段2'"
          v-model="form.main.sf_text2" slot="sf_text2" hidden="true" />
          <custom-field :readOnly="true" :label="customLabel.sf_text3 || '自定义字段3'"
          v-model="form.main.sf_text3" slot="sf_text3" hidden="true" />
          <custom-field :readOnly="true" :label="customLabel.sf_text4 || '自定义字段4'"
          v-model="form.main.sf_text4" slot="sf_text4" hidden="true" />
          <custom-field :readOnly="true" :label="customLabel.sf_text5 || '自定义字段5'"
          v-model="form.main.sf_text5" slot="sf_text5" hidden="true" />
        </custom-layout>
      </div>

      <div class="form-preview weui-form-preview">
        <div
          class="weui-form-preview__bd form-detail-preview"
          v-for="item in form.items"
          :key="item.sd_id"
        >
          <div class="form-detail-preview_num">{{item.sd_detno}}</div>
           <custom-layout :view-config="customViewConfig" position="detail1">
          <div class="weui-form-preview__item" slot="sd_custname">
            <label class="weui-form-preview__label">{{customLabel.sd_custname || "客户名称"}}</label>
            <span class="weui-form-preview__value">{{item.sd_custname}}</span>
          </div>
          <div class="weui-form-preview__item" slot="pr_detail">
            <label class="weui-form-preview__label">{{customLabel.pr_detail || "产品名称"}}</label>
            <span class="weui-form-preview__value">{{item.productDTO.pr_detail}}</span>
          </div>
          <div class="weui-form-preview__item" slot="pr_orispeccode">
            <label class="weui-form-preview__label">{{customLabel.pr_orispeccode || "型号"}}</label>
            <span class="weui-form-preview__value">{{item.productDTO.pr_orispeccode}}</span>
          </div>
          <div class="weui-form-preview__item" slot="pr_unit">
            <label class="weui-form-preview__label">{{customLabel.sd_qty || "数量"}}</label>
            <span class="weui-form-preview__value">{{item.sd_qty}} {{item.productDTO.pr_unit}}</span>
          </div>
          <div class="weui-form-preview__item" slot="sd_yqty">
            <label class="weui-form-preview__label">{{customLabel.sd_yqty || "已核销数量"}}</label>
            <span class="weui-form-preview__value">{{item.sd_yqty}} {{item.productDTO.pr_unit}}</span>
          </div>
          <div class="weui-form-preview__item" slot="sd_delivery">
            <label class="weui-form-preview__label">{{customLabel.sd_delivery || "交货日期"}}</label>
            <span class="weui-form-preview__value">{{item.sd_delivery}}</span>
          </div>
          <custom-field :readOnly="true" :label="customLabel.sd_text1 || '自定义字段1'"
            v-model="item.sd_text1" slot="sd_text1" hidden="true" />
            <custom-field :readOnly="true" :label="customLabel.sd_text2 || '自定义字段2'"
            v-model="item.sd_text2" slot="sd_text2" hidden="true" />
            <custom-field :readOnly="true" :label="customLabel.sd_text3 || '自定义字段3'"
            v-model="item.sd_text3" slot="sd_text3" hidden="true" />
            <custom-field :readOnly="true" :label="customLabel.sd_text4 || '自定义字段4'"
            v-model="item.sd_text4" slot="sd_text4" hidden="true" />
            <custom-field :readOnly="true" :label="customLabel.sd_text5 || '自定义字段5'"
            v-model="item.sd_text5" slot="sd_text5" hidden="true" />
           </custom-layout>
        </div>
      </div>
    </div>

    <div class="footer-bar weui-dialog__ft" v-if="!readonly">
      <router-link
        :to="'/sale/forecast_edit?id='+form.main.id"
        v-if="editable"
        class="weui-dialog__btn weui-dialog__btn_primary"
      >编辑</router-link>
      <a
        href="javascript:;"
        v-if="editable"
        class="weui-dialog__btn weui-dialog__btn_primary"
        @click="f_audit"
      >审核</a>
      <a
        href="javascript:;"
        v-if="editable"
        class="weui-dialog__btn weui-dialog__btn_default"
        @click="p_remove"
      >删除</a>
      <a
        href="javascript:;"
        v-if="!editable"
        class="weui-dialog__btn weui-dialog__btn_default"
        @click="f_unaudit"
      >反审</a>
    </div>
  </div>
</template>

<script>
import CustomLayout from "@/components/layout/CustomLayout.vue";
import process from "@/mixins/process.js";
import CustomField from "@/components/field/CustomField.vue";

export default {
  mixins: [process],
  components: {
    CustomLayout,
    CustomField
  },
  data() {
    return {
      baseUrl: "/api/sale/saleforecast",
      codeField: "sf_code",
      statusField: "sf_statuscode",
      caller: "SaleForecast",
      xtype: "sale-saleforecast-formpanel",
    };
  }
};
</script>